import author from '../tiles/author.html';
import blank from '../tiles/blank.html';
import category from '../tiles/category.html';
import comments from '../tiles/comments.html';
import headline from '../tiles/headline.html';
import headlineOverImage from '../tiles/headlineOverImage.html';
import image from '../tiles/image.html';
import insight from '../tiles/insight.html';
import insightOverImage from '../tiles/insightOverImage.html';
import likes from '../tiles/likes.html';
import publishDate from '../tiles/publishDate.html';
import publisher from '../tiles/publisher.html';
import social from '../tiles/social.html';
import source from '../tiles/source.html';
import tag from '../tiles/tag.html';
import _ from 'lodash';

let tileTemplates = {
	author,
	blank,
	category,
	comments,
	headline,
	headlineOverImage,
	image,
	insight,
	insightOverImage,
	likes,
	publishDate,
	publisher,
	social,
	source,
	tag,
};

/**
 * Base class for a 2-by-3 group of tiles
 */
export class Tileset {
	/**
	 * Assign post data to this tile
	 * @param {Object} post
	 */
	load(post) {
		/**
		 * The post assigned to this tile
		 * @type {Object}
		 */
		this.post = post;
		this.loadTileTypes();
	}

	/**
	 * Build an HTML string based on the metadata tiles and content tiles
	 * @returns {string}
	 */
	getUncompiledHtml() {
		/**
		 * The tiles used in this tileset
		 * @type {Array}
		 */
		this.tiles = [];
		let metaTypes = this.getMetaTypes(this.post);
		let blocks = [];
		this.tileTypes.forEach((type, i) => {
			if (!type) {
				console.log('incoming tile type is falsy :(', i);
			}
			if (type == 'meta') {
				type = metaTypes.shift();
			}
			if (!type) {
				console.log('tile type is falsy :(', this.tileTypes, i);
			}
			blocks.push(`
				<div class="masonry-tile" style="${this.layout[i].style}">
					<div class="masonry-tile-inner">
						${tileTemplates[type].replace(/dimensions/g, this.getTileDimensions(this.layout[i].size))}
					</div>
				</div>
			`);
		});
		return blocks.join('\n');
	}

	/**
	 * Get the height and width of a tile given a size string
	 * @param {String} size  Size string such as "2x3"
	 * @returns {string}  A JS-syntax object string such as "{width:220,height:196}"
	 */
	getTileDimensions(size) {
		let lookup = {
			// at 1920x1080, a 1x1 tile is 220x196
			'2x2': { width: 420, height: 372 },
			'1x1': { width: 220, height: 196 },
			'2x1': { width: 420, height: 156 },
			'3x2': { width: 660, height: 372 },
			'1x2': { width: 220, height: 412 },
		};
		return '(' + JSON.stringify(lookup[size] || lookup['1x1']).replace(/"/g, '') + ')';
	}

	/**
	 * Get the types of meta tiles that the given post has data for
	 * @param {Object} post
	 * @returns {String[]}  A list of names of meta tile types
	 */
	getMetaTypes(post) {
		if (this.numMetaTiles === 0) {
			return [];
		}
		let metaTypes = [];
		if (post.masonry.hasCategory) {
			metaTypes.push('category');
		}
		if (post.masonry.hasSource) {
			metaTypes.push('source');
		}
		if (post.masonry.hasAuthor) {
			metaTypes.push('author');
		}
		if (post.masonry.hasPublisher) {
			metaTypes.push('publisher');
		}
		if (post.masonry.hasTags) {
			metaTypes.push('tag');
		}
		if (post.masonry.hasPubDate) {
			metaTypes.push('publishDate');
		}
		if (post.masonry.hasLikes) {
			metaTypes.push('likes');
		}
		if (post.masonry.hasComments) {
			metaTypes.push('comments');
		}

		metaTypes = _.shuffle(metaTypes);
		while (metaTypes.length < 8) {
			metaTypes.push('blank');
		}
		return metaTypes;
	}
}
